import styled from "styled-components";
import { colors } from "../../assets/styles";

export const Div = styled.div``;

export const LogoContainer = styled.div`
  box-shadow: 0 0 2px 2px
    ${(props) => (props.theme?.isDarkTheme ? "#2d2d2d" : "#f9f9f9")};
  border: 1px solid
    ${(props) => (props.theme?.isDarkTheme ? "#737373" : "#eaeaea")};
  border-radius: 15px;
  padding: 1px;
`;

export const Logo = styled.img`
  width: 120px;
`;

export const Title = styled.div`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackSeven
      : colors.textColorBlackSix};
`;

export const ItemData = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackOne};
`;

export const Icon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackFive};
`;
